import { useEffect, useState } from "react";
import {
	operationModeToggleEnum,
	scanToCreateModeOption,
} from "resources/orders/Show/PickingList/components/OperationModeToggleFilter";

const manualModeToggleEnumValue = operationModeToggleEnum[1].value;

export const useOperationMode = ({ canScanToCreatePallet }) => {
	const defaultOperationMode = manualModeToggleEnumValue;
	const [operationMode, setOperationMode] = useState(defaultOperationMode);

	const isScanToCreatePalletActive =
		canScanToCreatePallet && operationMode === scanToCreateModeOption.value;

	// Resets to the default mode when scan-to-create stops being available so a stale mode can't linger.
	useEffect(() => {
		if (!canScanToCreatePallet && operationMode === scanToCreateModeOption.value) {
			setOperationMode(defaultOperationMode);
		}
	}, [canScanToCreatePallet, operationMode, defaultOperationMode]);

	return { operationMode, setOperationMode, defaultOperationMode, isScanToCreatePalletActive };
};
